import React from 'react'
import './login.css'
import { connect } from 'react-redux'
import {userList} from '../../redux/chatuser.redux.js'
import {getInFoFn} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { Link} from "react-router-dom"
import {getUnReadNum} from '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getInFoFn,getUnReadNum}
)
class LoginBar extends React.Component{

	constructor(props){
		super(props)
		this.state={
			tiyan:false
			
		}
		const MyOrigin = window.location.origin
		this.pathname = MyOrigin +''+ this.props.location.pathname
		this.vipGrowth=''
		
	}
	 handleVipGrowth(data){
	 	
	 	var num = parseInt(data/10000000*124)
	    
	    if(num>124){
	    	num = 124
	    }
	    if(num<1){num=1}

	      this.vipGrowth = num+'px'
	    
	  
	    }
	componentDidMount(){
		
		this.props.getInFoFn()
		
		this.props.getUnReadNum()
		
	}
	
	handleLogin(){
		/*		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+window.location.href)
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
		
		*/
		const ipath = {
		    pathname:'/login',
		    query:this.props.location.pathname
		}

		this.props.history.push(ipath)
	}
	handleLogout(){		
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
	}
	handleTiYan(){
		this.props.history.push('/my-member/2800')
		window.scrollTo(0,2800)
	}
	render(){
	
		if(this.props.userlist.gradeInfo){this.handleVipGrowth(this.props.userlist.gradeInfo.curVipGrowth)}
		
		var  loginLevel = this.props.userlist.gradeInfo?this.props.userlist.gradeInfo.vipGrade:''	
		const inFoMsg = this.props.inFoMsg
		if(loginLevel&&loginLevel<=1||loginLevel===0){
			loginLevel= 'login-level-1'
		}else if(loginLevel<=4&&loginLevel>1){
			loginLevel= 'login-level-2'
		}else if(loginLevel>4&&loginLevel<=7){
			loginLevel= 'login-level-3'
		}else if(loginLevel>=8){
			
			loginLevel= 'login-level-4'
		}else if(!loginLevel&&!this.props.showLogin){
			loginLevel= 'login-level-0'
		}
		
		const {children,showLogin} = this.props
		return (
			<div className="login">
				<strong className={loginLevel}></strong>
				
				{
					!showLogin&&<div className="unLogin">
						<span>LOGIN</span>
		                <button onClick={this.handleLogin.bind(this)}></button>
		                <em>查看专属你的服务、游戏等特权</em>
                	</div>

				}
				{
                showLogin&&<div className="login-detail">
					{ children }

					{
						inFoMsg.vipGrade>inFoMsg.curVipGrade?
							<div className="tiyan" onClick={()=>this.handleTiYan()}>体验</div>
							:null
					}

					<div className="login-index-detail">
                    <span className="span1">{this.props.inputUserId}</span>
                    <div className="integral-box">
                        <div className="integral-num" style={{"width":this.vipGrowth}}></div>
                        <Link to="/my-member" className="integral-answer">?</Link>
                    </div>
                    <div className="integral-dec">
                        <div className="integral-msg">
                            <Link to="/my-message">{this.props.unRead}</Link>
                            <span>我的消息</span>
                        </div>
                         <div className="integral-welfare">
                         	<Link to="/my-welfare">查看</Link>
                           
                            <span>我的福利</span>
                        </div>
                    </div>
                </div>
                </div>
                }
      		</div>

		)
	}

}

export default LoginBar



// WEBPACK FOOTER //
// ./src/component/login/login.js